import styled from "styled-components";

const Warning = styled.div`
  position: absolute;
  top: 24px;
  left: 8px;
  right: 0;
  z-index: 2;
  background-color: ${(props) => props.theme.paleAqua};
  color: ${(props) => props.theme.black};
  font-size: 1rem;
  font-weight: bold;
  line-height: 1;
  padding: 0.6rem 1.2rem;
  min-width: 220px;
  width: 100%;
  margin: 0;
  border: 1px solid ${(props) => props.theme.smalt};
  border-radius: 0.4rem;

  .title {
    font-size: 1.2rem;
    font-weight: 400;
  }

  a {
    color: ${(props) => props.theme.smalt};
  }

  @media (max-width: 339px) {
    min-width: 170px;
  }

  @media (min-width: 340px) and (max-width: 357px) {
    min-width: 188px;
  }

  @media (min-width: 358px) and (max-width: 374px) {
    min-width: 210px;
  }

  .subtext {
    font-size: 1rem;
    line-height: 1.4rem;
  }
`;

export default Warning;
